module.exports = __webpack_public_path__ + "static/img/role.abce978.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/yzzzbq/role.png
// module id = quHK
// module chunks = 7